<template>
  <div class="block__overflow animated animatedFadeInUp fadeInUp">
    <div class="buyOut">
      <div class="buyOut__th">
        <div class="buyOut__flex">
          <div class="title buyOut__title">География выкупов</div>
          <nav  class="filters__nav" v-click-outside="closeMenu">
            <div class="filters__nav-title" @click="openMenu">Сортировать {{this.currentActiveMenu}}</div>
            <ul class="filters__menu" :class="{'filters__menu_active': isOpenMenu}">
              <li class="filters__item filters__item_padding-left" :class="{'filters__item_active': currentActiveMenu === 'по id магазина от большего'}" @click="selectSort($event)">по id магазина от большего</li>
              <li class="filters__item filters__item_padding-left" :class="{'filters__item_active': currentActiveMenu === 'по id магазина от меньшего'}" @click="selectSort($event)">по id магазина от меньшего</li>
              <li class="filters__item filters__item_padding-left" :class="{'filters__item_active': currentActiveMenu === 'по кол-ву от большего'}" @click="selectSort($event)">по кол-ву от большего</li>
              <li class="filters__item filters__item_padding-left" :class="{'filters__item_active': currentActiveMenu === 'по кол-ву от меньшего'}" @click="selectSort($event)">по кол-ву от меньшего</li>
              <li class="filters__item filters__item_padding-left" :class="{'filters__item_active': currentActiveMenu === 'по сумме от большей'}" @click="selectSort($event)">по сумме от большей</li>
              <li class="filters__item filters__item_padding-left" :class="{'filters__item_active': currentActiveMenu === 'по сумме от меньшей'}" @click="selectSort($event)">по сумме от меньшей</li>
            </ul>
          </nav>
        </div>
        <div class="buyOut__summ-shops">
          <div class="buyOut__name" ref="storeCount"></div>
          <div class="buyOut__count" ref="deviceCount"></div>
          <div class="buyOut__summ" ref="moneySum"></div>
        </div>
      </div>
    </div>

    <template v-if="isStoreCount">
      <template v-for="(item) in elasticInfo.aggregations.Store">
        <template v-for="(bucket, index) in item">
          <div class="buyOut__item" :key="bucket.key + index - index" v-if="bucket.doc_count !== 0"
               :class="{
						'salesOnDay__tr_green': formatPrice(bucket.sum.value) === formatPrice(setMaxNumber),
						'salesOnDay__tr_red' : formatPrice(bucket.sum.value) === formatPrice(setMinNumber)
						} ">
            <div class="buyOut__name">{{shops.find(obj => obj.id === bucket.key) ? shops.find(obj => obj.id === bucket.key).name : bucket.key}}
            </div>
            <div class="buyOut__count">{{formatPrice(bucket.doc_count)}} шт.</div>
            <div class="buyOut__summ">{{formatPrice(bucket.sum.value)}} ₸</div>
          </div>
        </template>
      </template>
    </template>
    <template v-else>
      <div class="not-found not-found_margin-top">
        <img class="" src="../assets/images/not-found.png" alt="">
        <div class="not-found__title">Выкупов не найдено</div>
        <div class="not-found__text">Попробуйте изменить настройки фильтра</div>
      </div>
    </template>

    <div class="footer__info"><p>Информация актуальна на {{lastUpdate}}. Обновление каждые 6 часов.</p></div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations} from 'vuex';
  import ClickOutside from 'vue-click-outside';

  export default {
    name: 'MainTable',
    data:() => ({
      isOpenMenu: false,
      currentActiveMenu: 'по сумме от меньшей',
      isStoreCount: false
    }),
    computed: {
      ...mapState(['elasticInfo', 'shops','lastUpdate']),
      setMaxNumber() {
        let maxNumberArray = [];
        this.elasticInfo.aggregations.Store.buckets.map(info => {
          maxNumberArray.push(info.sum.value);
        });

        return Math.max(...maxNumberArray);
      },
      setMinNumber() {
        let maxNumberArray = [];
        this.elasticInfo.aggregations.Store.buckets.map(info => {
          if(info.sum.value > 0) {
            maxNumberArray.push(info.sum.value);
          }
        });

        return Math.min(...maxNumberArray);
      },
      deviceCount() {
        let moneySum;
        if(this.elasticInfo.aggregations.DeviceCount.value > 0) {
          moneySum = this.elasticInfo.aggregations.DeviceCount.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        } else {
          moneySum = '--';
        }
        return moneySum;
      },
      moneySum() {
        let moneySum;
        if(this.elasticInfo.aggregations.MoneySum.value > 0) {
          moneySum = this.elasticInfo.aggregations.MoneySum.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        } else {
          moneySum  = '--';
        }
        return moneySum;
      },
      storeCount() {
        let moneySum;
        if(this.elasticInfo.aggregations.StoreCount.value > 0) {
          moneySum = 'Магазинов: ' + this.elasticInfo.aggregations.StoreCount.value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")
        } else {
          moneySum  = '--';
        }
        return moneySum;
      },
    },
    watch: {
      elasticInfo(data) {

        if(data.aggregations.StoreCount.value !== undefined) {
          this.isStoreCount = true;
          this.$refs.storeCount.innerText = this.storeCount + ' шт.'
        }

        if(data.aggregations.MoneySum.value !== undefined) {
          this.$refs.moneySum.innerText = this.moneySum + ' ₸'
        }

        if(data.aggregations.DeviceCount.value !== undefined) {
          this.$refs.deviceCount.innerText = this.deviceCount + ' шт.'
        }
      }
    },
    methods: {
      ...mapActions(['SET_FILTER_VALUE']),
      ...mapMutations(['setSort']),
      openMenu(event) {
        this.isOpenMenu = !this.isOpenMenu;
        event.stopPropagation();
      },
      closeMenu() {
        this.isOpenMenu = false;
      },
      selectSort(value) {
        this.currentActiveMenu = value.target.innerText;

        switch (this.currentActiveMenu) {
          case 'по кол-ву от большего':
            this.setSort({value: 'desc', key: '_count'});
            break;
          case 'по кол-ву от меньшего':
            this.setSort({value: 'asc', key: '_count'});
            break;
          case 'по сумме от большей':
            this.setSort({value: 'desc', key: 'sum'});
            break;
          case 'по сумме от меньшей':
            this.setSort({value: 'asc', key: 'sum'});
            break;
          case 'по id магазина от меньшего':
            this.setSort({value: 'asc', key: '_key'});
            break;
          case 'по id магазина от большего':
            this.setSort({value: 'desc', key: '_key'});
            break;
        }
        this.isOpenMenu = false;


        this.SET_FILTER_VALUE();
      },
      formatPrice(value) {
        return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
      }
    },
    directives: {
      ClickOutside
    },
  };
</script>

<style scoped>

</style>
